<div class="navigation-step">
    <span class="back-button">
        <button pripple="" class="back-button back-button-action" type="button" [disabled]="backButtonDisabled" (click)="onClicButtonBack()">
            <i class="ri-arrow-left-line"></i>
        </button>
    </span>
    <h2 class="step-name">{{ stepTitle | translate }}</h2>
    <span class="back-button"> </span>
</div>
